import { Box, BoxProps } from "@chakra-ui/react";
import AddWbr from "components/Shared/AddWbr";
import { splitExt } from "utils/files/utils";

type WbrNameProps = {
  filename: string;
};

function WbrName({ filename }: WbrNameProps) {
  const parts = filename.split(/([_\-.\s/\\]+)/);
  return <AddWbr parts={parts} />;
}

type Props = BoxProps & {
  filename: string;
};

export default function Filename({ filename, ...rest }: Props) {
  const [basename, ext] = splitExt(filename);
  const isTruncated = rest.isTruncated || rest.noOfLines === 1;
  return (
    <Box noOfLines={isTruncated ? undefined : 2} {...rest}>
      {isTruncated ? basename : <WbrName filename={basename} />}
      {ext && (
        <Box as="span" opacity={0.25}>
          .{ext}
        </Box>
      )}
    </Box>
  );
}
